<template>
  <div>
    <div class="row">
      <div class="form-group col-md-4">
        <label for="category">{{ $t('event.form.category') }}</label>
        <input
          v-model.trim="event.category"
          name="category"
          type="text"
          class="form-control"
          id="category"
          v-bind:placeholder="$t('event.form.category')"
        />
      </div>

      <div class="form-group col-md-4">
        <label for="role">{{ $t('event.form.group') }} *</label>
        <!-- <select
          v-model="event.roles"
          v-validate="'required'"
          class="form-control"
          id="role"
          :placeholder="$t('event.form.group')"
        >
          <option v-for="s in roles" :value="s.item1" :key="s.item1">{{s.item2}}</option>
        </select> -->

        <multiselect
          v-model="event.roles"
          :options="roles"
          :multiple="true"
          :close-on-select="false"
          :clear-on-select="false"
          :hide-selected="true"
          :preserve-search="true"
          :preselect-first="true"
          :track-by="trackBy"
          placeholder="Choisir des roles"
          label="item1"
           v-validate="'required'"
            :data-vv-as="$t('event.form.group')"
           name='groups'
           id='groups'
        ></multiselect>
         <span
                class="text-danger"
                v-if="errors.has('groups')"
              >{{ errors.first('groups') }}</span>
      </div>
    </div>

    <div class="row">
      <div class="form-group col-md-4">
        <label for="titleInputFrench">{{ $t('event.form.title_french') }} *</label>
        <input
          v-model.trim="event.title.french"
          name="title_french"
          type="text"
          v-validate="'required'"
          :data-vv-as="$t('event.form.title_french')"
          class="form-control"
          id="titleInputFrench"
          v-bind:placeholder="$t('event.form.title_french')"
        />
          <span
                class="text-danger"
                v-if="errors.has('title_french')"
              >{{ errors.first('title_french') }}</span>
      </div>
      <div class="form-group col-md-4">
        <label for="titleInputEnglish">{{ $t('event.form.title_english') }} *</label>
        <input
          v-model.trim="event.title.english"
          name="title_english"
          v-validate="'required'"
          type="text"
           :data-vv-as="$t('event.form.title_english')"
          class="form-control"
          id="titleInputEnglish"
          v-bind:placeholder="$t('event.form.title_english')"
        />
         <span
                class="text-danger"
                v-if="errors.has('title_english')"
              >{{ errors.first('title_english') }}</span>
      </div>
    </div>

    <div class="row">
      <div class="form-group col-md-2">
        <label for="startDateAndTime">{{ $t('event.form.startDate') }}</label>
        <moment-date-picker v-model="event.startDateAndTime"></moment-date-picker>
      </div>
      <div class="form-group col-md-2">
        <label for="startTime">Heure</label>
        <cleave v-model="event.startTime" :raw="false" :options="options" class="form-control" id="startTime"
          v-bind:placeholder="$t('event.form.hourMinute')" name="startTime"></cleave>
      </div>
      <div class="form-group col-md-2">
        <label for="endDateAndTime">{{ $t('event.form.endDate') }}</label>
        <moment-date-picker v-model="event.endDateAndTime"></moment-date-picker>
      </div>
      <div class="form-group col-md-2">
        <label for="endTime">Heure</label>
        <cleave :raw="false" v-model="event.endTime" :options="options" class="form-control" id="endTime"
          v-bind:placeholder="$t('event.form.hourMinute')" name="endTime"></cleave>
      </div>
    </div>

    <div class="row">
      <div class="form-group col-md-6">
        <label for="description_french">{{ $t('event.form.shortDescription') }} (français)</label>
        <textarea
          v-model="event.shortDescription.french"
          name="shortdescription_french"
          id="shortdescription_french"
          class="form-control"
        ></textarea>
      </div>
      <div class="form-group col-md-6">
        <label for="description_english">{{ $t('event.form.shortDescription') }} (anglais)</label>
        <textarea
          v-model.trim="event.shortDescription.english"
          name="shortdescription_english"
          id="shortdescription_english"
          class="form-control"
        ></textarea>
      </div>
    </div>

    <!-- <div class="row">
      <div class="form-group col-md-6">
        <label for="description_french">{{ $t('event.form.description') }} (français)</label>
        <ckeditor
          :editor="editor"
          v-model.trim="descriptionInitialize"
          name="description_french"
          id="description_french"
        ></ckeditor>
      </div>
      <div class="form-group col-md-6">
        <label for="description_english">{{ $t('event.form.description') }} (anglais)</label>
        <ckeditor
          :editor="editor"
          v-model.trim="descriptionEnInitialize"
          name="description_english"
          id="description_english"
        ></ckeditor>
      </div>
    </div> -->

        <div class="row">
      <div class="form-group col-md-6">
        <label for="description_french">{{ $t('event.form.description') }} (français)</label>
        <rte
          v-model.trim="descriptionInitialize"
          name="description_french"
          id="description_french"
        ></rte>
      </div>
      <div class="form-group col-md-6">
        <label for="description_english">{{ $t('event.form.description') }} (anglais)</label>
        <rte
          v-model.trim="descriptionEnInitialize"
          name="description_english"
          id="description_english"
        ></rte>
      </div>
    </div>

    <div class="row">
      <div class="form-group col-md-12">
        <label for="place">{{ $t('event.form.place') }}</label>
        <ckeditor :editor="editor" v-model.trim="placeInitialize" name="place" id="place"></ckeditor>
      </div>
    </div>

    <div class="row" v-if="typeIn(3,5)">
      <div class="form-group col-md-6">
        <label for="eventBriteLink">{{ $t('event.form.eventBriteLink') }}</label>
        <input
          v-model.trim="event.eventBriteLink"
          name="eventBriteLink"
          type="text"
          class="form-control"
          id="eventBriteLink"
          v-bind:placeholder="$t('event.form.eventBriteLink')"
        />
      </div>
    </div>

    <create-event-person
      v-if="typeIn(5)"
      :compMode="compMode"
      :eventPersons="event.eventPersons"
      :members="members"
    ></create-event-person>
  </div>

  
</template>
<script>
import {
  EventServiceClient,
  EventProjectDto,
  EventPersonDto,
  EventInterestDto,
  MemberServiceClient,
} from '../../shared/service-clients/service-clients'
import ServiceFactory from '../../shared/service-clients/serviceClientFactory'
import CrudMixin from '../../shared/Mixin/CrudMixin'
import CreateEventPerson from './CreateEventPerson'
import Rte from '../../shared/components/Rte'
import Multiselect from 'vue-multiselect'
import moment from 'moment'
import Cleave from 'vue-cleave-component'
export default {
  name: 'CreateCustomEvent',
  mixins: [CrudMixin],
  inject: ['$validator'],
  props: {
    event: {
      type: Object,
    },
    members: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      roles: [],
      editor: ClassicEditor,
      editorConfig: {
        // The configation of the editor.
      },
      trackBy: 'item1',
      initialValue: this.event.roles,
      options: {
        time: true,
        timePattern: ['h', 'm'],
      },
    }
  },
  watch: {
    initialValue: {
      immediate: true,
      handler(values) {
        let roles = []
        var self = this
        let eventService = ServiceFactory.create(EventServiceClient)
        let getCustomEventRoles = eventService.getCustomEventRoles()
        getCustomEventRoles.then(res => {
          self.roles = res
          if (values) {
            self.event.roles = self.roles.filter(x => values.includes(x[this.trackBy]))
          }
        })
      },
    },
  },
  computed: {
    descriptionInitialize: {
      //CKeditor cannot have null value
      get: function() {
        if (this.event.description.french == null) {
          return ' '
        }
        return this.event.description.french
      },
      // setter
      set: function(newValue) {
        this.event.description.french = newValue
      },
    },
    descriptionEnInitialize: {
      //CKeditor cannot have null value
      get: function() {
        if (this.event.description.english == null) {
          return ' '
        }
        return this.event.description.english
      },
      // setter
      set: function(newValue) {
        this.event.description.english = newValue
      },
    },
    placeInitialize: {
      //CKeditor cannot have null value
      get: function() {
        if (this.event.place == null) {
          return ' '
        }
        return this.event.place
      },
      // setter
      set: function(newValue) {
        this.event.place = newValue
      },
    },
  },
  methods: {
    fetchData: function() {
      //   let self = this;
      //   let eventService = ServiceFactory.create(EventServiceClient);
      //   let getCustomEventRoles = eventService.getCustomEventRoles();
      //   getCustomEventRoles.then(res => {
      //     self.roles = res;
      //   });
    },
    typeIn: function(...types) {
      return _.some(types, s => s == this.event.type)
    },
  },
  components: {
    CreateEventPerson,
    multiselect: Multiselect,
    Rte,
    Cleave,
  },
}
</script>


// WEBPACK FOOTER //
// src/components/events/CreateCustomEvent.vue